import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const createRFQ = (data)=>
  api.post(ENDPOINTS.BUYER_RFQS.CREATE,data);

export const listBuyerRFQs = (data)=>
  api.post(ENDPOINTS.BUYER_RFQS.SEARCH,data);